import client from './index';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async getBannerList(token: string) {
    try {
      const response = await client.get('/v2/banner/home', {headers: {'player-token': token}});
      return response.data;
    } catch (error) {
      console.log('An error occurred while fetching banners:', error);
      return null;
    }
  },
};
